import React from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { sanitiseLinks, wordpressImgToImgixURL } from 'Utilities';
import { classNamePropType } from 'Utilities/propTypes';

import styles from './Page.scss';

const Page = ({
  className, content, title, wordpressContent,
}) => {
  const history = useHistory();

  const linkClick = (e) => {
    const url = e.target.getAttribute('href') || e.target.parentNode.getAttribute('href');

    if (url && url.charAt(0) === '/' && !(e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey)) {
      e.preventDefault();

      history.push(url); // Expose router functions
    }

    if (url && /^#privacy-section/.test(url)) {
      e.preventDefault();
      e.target.classList.add('wp-privacy-link-hidden');
      document.getElementById(url.replace('#', '')).classList.add('active');
    }
  };

  const keyPress = (e) => {
    if (e.key.toLowerCase() === 'enter') {
      linkClick(e);
    }
  };

  return (
    <div
      className={cx(styles.component, className)}
      onClick={linkClick}
      onKeyDown={keyPress}
      {...wordpressContent}
      role="link"
      tabIndex={0}
    >
      <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
      <div dangerouslySetInnerHTML={{ __html: sanitiseLinks(wordpressImgToImgixURL(content)) }}></div>
    </div>
  );
};

Page.propTypes = {
  className: classNamePropType,
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  wordpressContent: PropTypes.shape({
    className: PropTypes.string,
  }).isRequired,
};
export default Page;
